import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    OrderSubType,
    ProductType,
} from 'app/enums/label.enums'

const config: SkyNetTableConfig = {
    name: 'ContainerSelection.InternalTransports',
    tabs: [{
        name: 'Open Transports',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'orderNumber',
                filterField: 'orderNumber',
                filterType: FilterType.Array,
                width: '100px',
                labelKey: 'ORDER',
            },
            {
                name: 'originAirportIataCode',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
                width: '135px',
                labelKey: 'ORIGIN_AIRPORT',
            },
            {
                name: 'destinationAirportIataCode',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
                width: '170px',
                labelKey: 'DESTINATION_AIRPORT',
            },
            {
                name: 'orderSubType',
                filterField: 'orderSubType',
                filterType: FilterType.Array,
                componentName: 'EnumValue',
                allowedValuesEnum: OrderSubType,
                labelKey: 'ORDER_SUBTYPE',
            },
            {
                name: 'originLocationLocationName',
                filterField: 'originLocationLocationName',
                filterType: FilterType.Array,
                labelKey: 'ORIGIN_LOCATION',
            },
            {
                name: 'destinationLocationLocationName',
                filterField: 'destinationLocationLocationName',
                filterType: FilterType.Array,
                labelKey: 'DESTINATION_LOCATION',
            },
            {
                name: 'plannedPickup',
                filterField: 'plannedPickup',
                filterType: FilterType.DateRange,
                componentName: 'DateTimeCell',
                labelKey: 'PLANNED_PICK_UP_ON',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                sorting: false,
                labelKey: 'REQUIRED_CONTAINERS',
            },
            {
                name: 'containerSelectionUntilUtc',
                componentName: 'ContainerSelectionUntil',
                labelKey: 'REMAINING_OVERDUE',
            },
        ],
    }],
}

export default config
